import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Zap, LayoutDashboard, LogOut, ShieldCheck } from "lucide-react";

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-border">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 font-display font-black text-xl tracking-tight">
          <span className="grid place-items-center w-8 h-8 rounded-md bg-primary text-primary-foreground">
            <Zap className="w-5 h-5" />
          </span>
          Dirt Or Road
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-semibold">
          <Link to="/bikes" data-testid="nav-bikes" className="hover:text-primary transition-colors">Browse Bikes</Link>
          <Link to="/#servicing" data-testid="nav-servicing" className="hover:text-primary transition-colors">Servicing</Link>
          <Link to="/#requirements" data-testid="nav-requirements" className="hover:text-primary transition-colors">Requirements</Link>
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              {user.role === "admin" ? (
                <Button variant="ghost" size="sm" data-testid="nav-admin" onClick={() => navigate("/admin")} className="hidden sm:flex gap-2 hover:text-primary">
                  <ShieldCheck className="w-4 h-4" /> Admin
                </Button>
              ) : (
                <Button variant="ghost" size="sm" data-testid="nav-dashboard" onClick={() => navigate("/dashboard")} className="hidden sm:flex gap-2 hover:text-primary">
                  <LayoutDashboard className="w-4 h-4" /> Dashboard
                </Button>
              )}
              <Button variant="ghost" size="sm" data-testid="nav-logout" onClick={handleLogout} className="gap-2 hover:text-primary">
                <LogOut className="w-4 h-4" /> Logout
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" data-testid="nav-login" onClick={() => navigate("/login")} className="hover:text-primary">
                Log in
              </Button>
              <Button size="sm" data-testid="nav-signup" onClick={() => navigate("/register")} className="bg-primary hover:bg-[#1D4ED8] text-white font-bold">
                Get Started
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
